/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SyncTodosRequest} from '@cash-web/protos/squareup/stafftasks/managertodos/endpoints/sync-todos.pb'
import {SyncTodosResponse} from '@cash-web/protos/squareup/stafftasks/managertodos/endpoints/sync-todos.pb'


export const syncTodos = (request: SyncTodosRequest, options?: CashRequestOptions) => post<SyncTodosRequest, SyncTodosResponse>("/2.0/cash/sync-todos", request, {...options, rejectOnError: true })